package com.bulut.mecitogullari.core.platform

actual val isExitConfirmationSupported: Boolean = false

actual fun exitApp() = Unit
